import { Icon } from '@chakra-ui/react';

export const ManagerScoreBold = (props) => (
  <Icon viewBox="0 0 24 24" boxSize="16px" color="icon.g1" {...props}>
    <path
      d="M7.20117 12.416C7.20117 11.9467 7.55244 11.5594 8.0064 11.5027L10.649 18.7097C10.6882 18.8166 10.7379 18.9135 10.7962 19.0004H8.02882C7.57172 19.0004 7.20117 18.6298 7.20117 18.1727V12.416ZM15.9711 19.0004H12.9513C13.0066 18.918 13.0542 18.8266 13.0926 18.7261L15.8503 11.5063C16.3862 11.5811 16.7988 12.0414 16.7988 12.598V18.1727C16.7988 18.6298 16.4282 19.0004 15.9711 19.0004Z"
      stroke="currentColor"
      strokeWidth="2"
      fill="transparent"
    />
    <path d="M10.916 13.1415L12.0589 16.5701L13.2017 13.1415L12.0589 11.4272L10.916 13.1415Z" fill="currentColor" />
    <circle cx="12.0585" cy="7.42808" r="2.42857" stroke="currentColor" strokeWidth="2" fill="transparent" />
  </Icon>
);
